import React from 'react';

export default function StatCard({ label, value, valueColor = '#232323' }) {
  return (
    <div className="fm-card px-5 py-4 min-w-[180px] flex-1">
      <div className="text-[12px] text-[#7a6f5c] tracking-wide">{label}</div>
      <div className="font-serif text-[34px] leading-tight mt-1" style={{ color: valueColor }}>{value}</div>
    </div>
  );
}
